export const themeColours = {
  Crime: "#A21214",
  Jobs: "#CDCD00",
  Water: "#1F78B4",
  Roads: "#877C97",
  Housing: "#B15928",
  Community: "#32CD32",
  Immigration: "#137055",
  Healthcare: "#EB4762",
  "Service Delivery": "#800000",
  Corruption: "#FF6B58",
  Sanitation: "#05FFA1",
  Education: "#6A3D9A",
  Councillor: "#5A8F5A",
  Municipality: "#284D7D",
  "Refuse removal": "#B65A00",
  Health: "#D20076",
  Electricity: "#FDBF6F",
  "Housing Delivery": "#B4884F",
  Transport: "#228BDC",
  Grants: "#33A02C",
  Data: "#9239F6",
  "Small business": "#A47A01",
  COVID: "#907F98",
  Social: "#FF7F00",
  Other: "#666666",
};

export const getThemeColour = (theme: string): string => {
  return theme in themeColours
    ? themeColours[theme as keyof typeof themeColours]
    : themeColours.Other;
};
